import type { AppSettings } from "../services/appSetting.service";
import { isSettingEnabled, pickAppSettingValue } from "./salesSettings";

export type PurchaseColumnSettings = {
  showFree: boolean;
  showSdRs: boolean;
  /** PD% and PD Rs columns */
  showPdPercent: boolean;
  /** CD% and CD Rs columns */
  showCdPercent: boolean;
  showFrCost: boolean;
  showUnit: boolean;
};

export const DEFAULT_PURCHASE_COLUMN_SETTINGS: PurchaseColumnSettings = {
  showFree: true,
  showSdRs: true,
  showPdPercent: true,
  showCdPercent: true,
  showFrCost: true,
  showUnit: true,
};

export function getPurchaseColumnSettings(
  settings: AppSettings[],
  branchId: number,
): PurchaseColumnSettings {
  const pick = (key: string) =>
    pickAppSettingValue(settings, "purchase settings", key, branchId);

  return {
    showFree: isSettingEnabled(pick("free")),
    showSdRs: isSettingEnabled(pick("SD Rs")),
    showPdPercent: isSettingEnabled(pick("PD %")),
    showCdPercent: isSettingEnabled(pick("CD %")),
    showFrCost: isSettingEnabled(pick("Fr. Cost")),
    showUnit: isSettingEnabled(pick("Unit")),
  };
}
